import { searchParamKeys } from '../../../shared/configs/searchParams';
import { parseAcceptanceSlug } from '../../../shared/packages/acceptance';
import { useSearchParamsSelector } from '../../../shared/packages/searchParamsManager';

export const useCurrentAcceptanceHouseId = () =>
  useSearchParamsSelector((state) => {
    const { houseId } = parseAcceptanceSlug(state[searchParamKeys.acceptance]);
    return houseId;
  });
